import React from 'react';
import withIcon from '../utilities/withIcon';

const IconTableCol = () => {
  return (
    <g>
      <path d="M5.5 0v.005l9.451.012c.541 0 .986.41 1.043.936l.006.114V14.95c0 .541-.41.987-.936 1.044L14.95 16H1.05a1.05 1.05 0 0 1-1.044-.936L0 14.95V1.05C0 .51.41.064.936.007L1.05 0 4 .004V0h1.5zm-4 13.144V14.5h2.194L1.5 13.144zm4-11.638V14.5h9V1.516l-9-.01zm-4 8.287v1.709L4 13.047v-1.709L1.5 9.793zm0-3.299v1.657L4 9.696V8.039L1.5 6.494zm0-3.35v1.708L4 6.397V4.689L1.5 3.144zM4 1.504l-2.5-.003L4 3.047V1.504z" />
    </g>
  );
};

export default withIcon(IconTableCol);
